<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-btn color="success"
                       @click="Nuevo()"
                       class="ma-2 white--text">
                    Nuevo
                </v-btn>
                <v-card class="text-xs-center ma-1">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Reportes Automáticos</span>
                    </v-card-title>
                    <v-card-text>
                        <DataTable :url="url"
                                   class="tablaMain"
                                   :columns="head"
                                   :formatterActions="formatterActions"
                                   :params="displayInputs"
                                   :order="[]"
                                   @apiDT="apiDT = $event">
                        </DataTable>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import Sistemas from "@/services/Sistemas/sistemas.service.js";
    import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable,
            Menu,
        },
        data() {
            return {
                showcargando: true,
                apiDT: null,
                url: 'Sistemas/Listado',
                displayInputs: {},
                head: [
                    { name: "shsp", data: "shsp", title: "Reportes", formatter: [this, "DetalleTarea"], },
                    { name: "shfhproximos", data: "shfhproximos", title: "Próximo Envió" },
                    { name: "Error", data: "Error", title: "Última ejecución", formatter: [this, "Estado"], },
                    { name: "shestadotexto", data: "shestadotexto", title: "Estatus", },
                    { name: "shtipo", data: "shtipo", title: "Ejecutar", formatter: [this, "Ejecutar"], },
                    { name: "shclave", data: "shclave", title: "Editar", formatter: [this, "Editar"], },
                    { name: "shestado", data: "shestado", title: "Habilitar/Deshabilitar", formatter: [this, "Ejecucion"], },
                ],
                formatterActions: [
                    { click: [this, "VerTarea"] },
                    { click: [this, "VerEditar"] },
                    { click: [this, "CambiarEjecucion"] },
                    { click: [this, "EjecutarTarea"] },
                ],
                columnDefs: [
                    {
                        targets: 2, // Tu primera columna
                        className: "dt-body-right",
                    }
                ],
            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        methods: {
            Ejecutar(datos) {
                if (datos.shtipo == 'RA' && datos.shestado == true)
                    return `<div class="ml-3"><button type="button" data-action="3" data-params="${datos.shclave}" class="dt-formatterAction ma-2 white--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default warning"><span class="v-btn__content"> Ejecutar </span></button></div>`;
                else
                    return ``;
            },
            Nuevo() {
                sessionStorage.removeItem('Tarea')
                this.$router.push({ name: 'ReporteA' }).catch((error) => error);
            },
            async EjecutarTarea(params, item, fila) {
                let formdata = new FormData();
                formdata.append("shclave", item.shclave);
                await Sistemas.EjecutarTarea(formdata).then(data => {
                    if (data.success == true) {
                        this.$swal(
                            "Exito",
                            "Reporte automático ejecutado correctamente.",
                            "success"
                        );
                    }
                    else {
                        this.$swal(
                            "Atención",
                            "El reporte automático no se ejecutó.",
                            "error"
                        );
                    }
                });
            },
            async VerEditar(params, item, fila) {
                await MetodosGenerales.guardarEnSesionInfoReporte(item, 'Tarea');
                this.$router.push({ name: 'ReporteA' });
            },
            async VerTarea(params, item, fila) {
                await MetodosGenerales.guardarEnSesionInfoReporte(item, 'Tarea');
                this.$router.push({ name: 'Historial' });
            },
            async CambiarEjecucion(params, item, fila) {
                let formdata = new FormData();
                formdata.append("shclave", item.shclave);
                formdata.append("shestado", item.shestado == false ? 1 : 0);
                await Sistemas.CambiarEstado(formdata).then(data => {
                    if (data.success == true) {
                        this.apiDT.ajax.reload();
                        this.$swal(
                            "Exito",
                            data.data,
                            "success"
                        );
                    }
                    else {
                        this.$swal(
                            "Atención",
                            data.data,
                            "error"
                        );
                    }
                });
            },
            DetalleTarea(datos) {
                if (datos.shclave > 0) {
                    return `<div class="ml-3"><button data-action="0" data-params="${datos.shclave}" class="dt-formatterAction ma-1 reporteindice">${datos.shsp}</span></button></div>`;
                } else {
                    return `<span>${datos.shsp}</span>`;
                }
            },
            Estado(datos) {
                if (datos.Error == null) {
                    return `<div aling="center" style="display:grid; place-items: center; text-align-last: center !important;"><span class="v-btn__content" title="Sin ejecución"><i aria-hidden="true" class="v-icon notranslate mdi mdi-minus blue-grey theme--dark"></i></span></div>`;
                }
                else if (datos.Error == false) {
                    return `<span style="display:grid; place-items: center;" class="v-btn__content" title="Ejecutado correctamente"><i aria-hidden="true" class="v-icon notranslate mdi mdi-check success theme--dark"></i></span>`;
                }
                else if (datos.Error == true) {
                    return `<span style="display:grid; place-items: center;" class="v-btn__content" title="Error al ejecutar"><i aria-hidden="true" class="v-icon notranslate mdi mdi-close error theme--dark"></i></span>`;
                }
            },
            Ejecucion(datos) {

                if (datos.shestado == true)
                    return `<div class="ml-3"><button type="button" data-action="2" data-params="${datos.shclave}" class="dt-formatterAction ma-2 white--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default blue-grey"><span class="v-btn__content"> Deshabilitar </span></button></div>`;
                else if (datos.shestado == false)
                    return `<div class="ml-3"><button type="button" data-action="2" data-params="${datos.shclave}" class="dt-formatterAction ma-2 white--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default blue-grey"><span class="v-btn__content"> Habilitar </span></button></div>`;
            },
            Editar(datos) {
                if (datos.shclave > 0)
                    return `<div class="ml-3"><button type="button" data-action="1" data-params="${datos.shclave}" class="dt-formatterAction ma-2 white--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"><span class="v-btn__content"> Editar </span></button></div>`;
            }
        },
        async mounted() {
            this.showcargando = false;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '60').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>